import * as React from "react"
import {
  Auth0Config,
  Auth0ConfigFragFragment,
  BecomeDriver,
  Booker as BOOKER,
} from "../graphql/queries"
import {auth0Url, redirectTo} from "./Auth0LockLink"
import {GraphQL} from "../graphql"
import {Loader} from "semantic-ui-react"
import {errorUnionToEither, handleError, OrError} from "../graphql/errors"
import {nullableToLeft} from "../tsutil"
import {history, WithModalStore} from "../App"
import {Booker} from "../model/BookingTypes"

interface PropsWithAuth0Config extends PropsWithBooker, WithModalStore {
  auth0Config: Auth0ConfigFragFragment
}

class DriverSignup extends React.Component<PropsWithAuth0Config, {loading: boolean}> {
  constructor(props: PropsWithAuth0Config) {
    super(props)
    this.state = {loading: true}
  }

  componentDidMount(): void {
    this.props.modalStore.handlePromiseThrow(this.componentDidMountAsync())
  }

  async componentDidMountAsync() {
    const {id, auth0Config, modalStore, booker} = this.props
    if (booker === null) {
      redirectTo(auth0Url(auth0Config, null, "signUp", true, true))
    } else {
      const result = await modalStore.applyModal({
        error: (m) => ["Driver signup failed", m],
        action: () => onBecomeDriver(id),
      })
      if (result.isRight()) {
        history.push("/bookings")
      }
      this.setState({loading: false})
    }
  }

  render() {
    return this.state.loading ? <Loader active /> : null
  }
}

interface PropsWithBooker extends OwnProps {
  booker: Booker | null
}

function DriverSignupWithAuth0Config(props: PropsWithBooker) {
  return (
    <GraphQL.Query
      query={Auth0Config}
      variables={{}}
      render={({data}) => {
        if (data) {
          return <DriverSignup {...props} auth0Config={data.auth0Config} />
        } else {
          return <Loader active />
        }
      }}
    />
  )
}

function DriverSignupWithBooker(props: OwnProps) {
  return (
    <GraphQL.Query
      query={BOOKER}
      variables={{}}
      render={({data}) => {
        if (data !== null) {
          return handleError(errorUnionToEither(data.booker), (data) => (
            <DriverSignupWithAuth0Config {...props} booker={data.booker} />
          ))
        }
        // This should not happen, as Booker is loaded in InitializeSession
        return <Loader active />
      }}
    />
  )
}

interface OwnProps extends WithModalStore {
  id: string
}

async function onBecomeDriver(id: string): Promise<OrError<void>> {
  const result = await GraphQL.mutate(BecomeDriver, {driverSmsId: id})
  return nullableToLeft(result.becomeDriver)
}

export {DriverSignupWithBooker as DriverSignup}



// WEBPACK FOOTER //
// ./src/components/DriverSignup.tsx